var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-with-tooltip__wrapper"},[_c('popper',{attrs:{"disabled":_vm.disableTooltip,"options":{
      placement: 'top',
      modifiers: { offset: { offset: '0, 2px' } }
    }}},[_c('div',_vm._b({staticClass:"text-with-tooltip__content",class:{ 'text-with-tooltip__content--green': _vm.makeActivatorTextGreen },attrs:{"slot":"reference"},slot:"reference"},'div',_vm.$attrs,false),[_vm._t("default")],2),_c('div',{staticClass:"popper text-with-tooltip__tooltip"},[_vm._t("tooltip")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }